module.exports = __webpack_public_path__ + "static/media/bg4.7cf1eea3.jpg";